import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {
	Backdrop,
	Button,
	Checkbox, CircularProgress, Dialog, DialogActions, DialogContent,
	DialogContentText, DialogTitle,
	Divider,
	FormControlLabel,
	Paper,
	Typography
} from "@mui/material";
import {useHistory, useParams} from "react-router-dom";
import clsx from 'clsx';
import Grid from "@mui/material/Grid";
import {FormProvider, useForm} from "react-hook-form";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import { Alert, AlertTitle } from '@mui/material';
import Background from "../../../assets/Ocean-bg.jpg";
import IconButton from "@mui/material/IconButton";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import Tooltip from "@mui/material/Tooltip";
import {useTheme} from "@mui/styles";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {AppContext} from "../../../App";
import {setCloseSnackbar, setOpenSnackbar, setThemeType} from "../../../services/AppServices";
import {SegnalazionePositivoGrid} from "./SegnalazionePositivoGrid";
import CustomMultiText from "../../widgets/inputs/CustomMultiText";
import {bigNoteRegisterNotRequired, emailRegister, valueRegister} from "../../../utils/RegisterUtils";
import Copyright from "../../auth/utils/Copyright";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import {
	OCEAN__MAIN_GLOBAL_THEMA_TEXT,
	OCEAN__GLOBAL_THEMA_TEXT_DARK
} from "../../../strings/IT";
import {getTamponeByIdNoAuth} from "../../../services/TamponiServices";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../reducers/TamponiReducer";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../reducers/IntervistaReducer";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../reducers/QuaranteneReducer";
import {languages} from "../../../strings/LanguageDictionary";
import CustomText from "../../widgets/inputs/CustomText";
import {generateIntervistaV2, setIntervista} from "../../../services/IntervistaServices";
import {getIntervistaApiData, getListaOf} from "../../../services/utils/IntervistaApiData";
import {generateQuarantenaV3} from "../../../services/QuaranteneServices";
import {sintomi} from "../../../utils/arrays/Generics";
import {InfoLavorativeGrid} from "../../gestione/interviste/intervista/content/InfoLavorativeGrid";
import {RadioGroupQuestion} from "../../widgets/inputs/RadioGroupQuestion";


const IntervistaCasoIndice = () => {
	const contattaciClasses = ContattaciStyle();
	const classes = BaseStyle();
	let theme = useTheme();
	let history = useHistory();
	const methods = useForm({
		mode: "onChange",
	});
	
	const [submit, setSubmit] = useState(false);
	const [submitQuarantena, setSubmitQuarantena] = useState(false);
	const [success, setSuccess] = useState(false);
	const appContext = useContext(AppContext);
	const [tamponiState, tamponiDispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [openInformativa, setOpenInformativa] = useState(true);
	const [read, setRead] = useState(false);
	const [startGetTampone, setStartGetTampone] = useState(true);
	let {idTampone} = useParams();
	
	const handleCloseSnack = useCallback(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch]);
	
	const onSubmit = useCallback((data) => {
		console.log(data);
		/**
		 * Togliendo il controllo di per sé non cambia nulla se non che c'è meno certezza di chi sta compilando
		 * l'intervista.
		 */
		//if (tamponiState.tampone["codF"] === data.codF?.toUpperCase()) {
		setSubmit(true);
		setIntervista(data, intervistaDispatch);
		generateIntervistaV2({
			...getIntervistaApiData(data),
			tipoContatto: "Caso indice",
			note: JSON.stringify(data.contatti),
			soggetto: {
				idSoggetto: tamponiState.tampone["idSoggetto"]
			},
			type: "PUB",
			tamponeId: idTampone,
		}, intervistaDispatch, false)
		/*} else {
		 setOpenSnackbar("warning", "Il codice fiscale indicato non corrisponde con quello del tampone positivo! Verifica di averlo scritto correttamente", appContext.dispatch)
		 }*/
	}, [tamponiState.tampone, intervistaDispatch, idTampone])
	
	useEffect(() => {
		if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista === "") {
			setSubmit(false);
			setSubmitQuarantena(true);
			let score = Math.round(getListaOf(sintomi, intervistaState.intervista)?.split(",")?.length * 4 / 11)
			generateQuarantenaV3(tamponiState.tampone["idSoggetto"], {
				...methods.getValues(),
				tipoContatto: "Caso indice"
			}, intervistaState.intervista.id, score, "PAZ_ZERO", idTampone, quarantenaDispatch);
		} else if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista !== "") {
			setSubmit(false);
			setOpenSnackbar("error", intervistaState.errorAddIntervista, appContext.dispatch);
		}
	}, [submit, intervistaState.loadingAddIntervista, intervistaState.errorAddIntervista, tamponiState.tampone,
		quarantenaDispatch, intervistaState.intervista, appContext.dispatch, methods, idTampone])
	
	useEffect(() => {
		if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena === "") {
			setSuccess(true);
		} else if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena !== "") {
			setSubmitQuarantena(false);
			setOpenSnackbar("error", quarantenaState.errorGenerateQuarantena, appContext.dispatch);
		}
	}, [submitQuarantena, quarantenaState.loadingGenerateQuarantena, quarantenaState.errorGenerateQuarantena, appContext.dispatch])
	
	useEffect(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch])
	
	useEffect(() => {
		setStartGetTampone(true);
		getTamponeByIdNoAuth(idTampone, tamponiDispatch)
	}, [idTampone, tamponiDispatch])
	
	useEffect(() => {
		if (startGetTampone && !tamponiState.loadingGetTampone && tamponiState.errorGetTampone === "") {
			setStartGetTampone(false);
		} else if (startGetTampone && !tamponiState.loadingGetTampone && tamponiState.errorGetTampone !== "") {
			setStartGetTampone(false);
			history.push("/404");
		}
	}, [startGetTampone, tamponiState.loadingGetTampone, tamponiState.errorGetTampone, history])
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
        <React.Fragment>
            <Backdrop open={submit} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
            <Backdrop open={startGetTampone} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
            <Backdrop open={submitQuarantena} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
            <main className={classes.mainNoBgCol}>
				<header className={contattaciClasses.header}>
					<Tooltip
						title={appContext.state.theme.palette.mode === "light" ? OCEAN__MAIN_GLOBAL_THEMA_TEXT : OCEAN__GLOBAL_THEMA_TEXT_DARK}>
						<IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000"}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
								appContext.state.theme, appContext.dispatch)}
                            size="large">
							{
								appContext.state.theme.palette.mode === "light" ?
									<Brightness4TwoToneIcon/> :
									<Brightness5TwoToneIcon/>
							}
						</IconButton>
					</Tooltip>
					<Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
						<b>Intervista epidemiologica</b>
					</Typography>
				</header>
				<article className={contattaciClasses.article}>
					<Paper
						className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<FormProvider {...methods}>
								<Grid container spacing={3}>
									<Grid item xs={12}>
										<Typography color={"textSecondary"}>
											Gentilissimo utente,<br/>
											hai ricevuto questo link dall'<b>ASL Città di Torino</b> in quanto sei risultato positivo al
											tampone effettuato in data (vedi mail o SMS).<br/>
											Ti invitiamo a compilare l'intervista epidemiologica per informare l'ASL riguardo i tuoi sintomi.
											<b>Rimani in isolamento</b> nel tuo domicilio. Ogni giorno a partire da
											oggi <b>riceverai un monitoraggio </b> tramite mail nella quale
											dovrai indicare i tuoi sintomi giorno per giorno: verrai contattato/a da un medico in caso
											venissero rilevate anomalie o criticità nei sintomi.<br/>
											A fine intervista ti verrà <b>prenotato un tampone molecolare o rapido di controllo</b> e verrai
											contattato il giorno prima per conferma.<br/>
										</Typography>
									</Grid>
									
									<Grid item xs={12}>
										<Alert severity={"info"}
										       style={{borderRadius: 24,}}>
											<AlertTitle><b>Attenzione</b></AlertTitle>
											É necessario indicare in modo corretto e completo tutti questi dati. Il codice fiscale viene
											utilizzato come ulteriore verifica della tua identità, l'indirizzo per il tuo isolamento
											(inserisci l'indirizzo completo) mentre la mail verrà utilizzata per inviarti
											il monitoraggio giornaliero ove necessario.
											<br/>
											<b>NB: Nella sezione finale indica solo i contatti conviventi.</b><br/>
											<br/>
											Ulteriori informazioni sul sito del governo al link:
											<a
												href={"https://www.salute.gov.it/portale/news/p3_2_1_1_1.jsp?lingua=italiano&menu=notizie&p=null&id=5789"}
												target={"_blank"} rel={"noreferrer"}>
												salute gov
											</a>
										</Alert>
									</Grid>
									
									<Grid item xs={12}>
										<Divider/>
									</Grid>
									
									<Grid item xs={12} sm={6}>
										<CustomText
											control={methods.control}
											rules={valueRegister}
											name={"codF"}
											label={languages[appContext.state.lang].ANAGRAFICA__VALORE_DOCUMENTO_}
											autoFocus={false}
											inputProps={{
												className: classes.input
											}}
											type={"text"}
											error={methods.errors["codF"]}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<CustomText
											control={methods.control}
											rules={{required: true}}
											name={"indirizzoDomiclio"}
											label={"Indirizzo di domicilio"}
											autoFocus={false}
											autoComplete={"indirizzoDomiclio"}
											error={methods.errors["indirizzoDomiclio"]}
										/>
									</Grid>
									<Grid item xs={12}>
										<CustomText
											control={methods.control}
											rules={emailRegister}
											name={"email"}
											label={"Email"}
											autoFocus={false}
											error={methods.errors["email"]}
										/>
									</Grid>
									
									<InfoLavorativeGrid isCit={true}/>
									<SegnalazionePositivoGrid showAlert={false}/>
									
									<Grid item xs={12}>
										<RadioGroupQuestion
											question={"Vuoi effettuare il tampone tramite l'Asl Città di Torino?"}
											control={methods.control}
											autoFocus={true}
											defaultValue={""}
											rules={{required: true}}
											name={"protocollo"}
											error={methods.errors["protocollo"]}
										/>
										<Typography color={"textSecondary"}>
											I tamponi effettuati presso gli Hot Spot dell'ASL CITTÁ DI TORINO <b>sono gratuiti</b>, ti verrà
											prenotato un tampone di controllo <i>(a seconda della tua situazione
											vaccini/guarigioni)</i> e verrai contattato il giorno prima per sapere il luogo e l'orario.
											<br/>
											Nel caso in cui decidessi di effettuare il tampone di controllo <b>privatamente</b>, ti ricordiamo
											che il <b>costo è a tuo carico</b>, verrai solamente monitorato per quelli che sono i tuoi sintomi
											giornalieri.
										</Typography>
									</Grid>
									
									<Grid item xs={12}>
										<CustomMultiText
											inputRef={methods.register(bigNoteRegisterNotRequired)}
											name={"noteQuarantena"}
											label={"Note particolari da indicare all'operatore"}
											autoFocus={false}
											error={methods.errors["noteQuarantena"]}
											rows={10}
										/>
									</Grid>
									
									<Grid item xs={12}>
										<Divider/>
									</Grid>
									<Grid item xs={12}>
										<Typography color={"textSecondary"}>
											Alla luce del nuovo DL 24 marzo 2022, n. 24, a partire dal 01.04.2022, a tutti coloro che hanno
											avuto contatti stretti con soggetti confermati positivi al Covid è applicato il regime
											dell' autosorveglianza (obbligo di indossare dispositivi FFP2 al chiuso o in presenza di
											assembramenti fino al decimo giorno successivo alla data dell’ultimo contatto stretto con il
											soggetto positivo); è prevista l’esecuzione immediata di un test diagnostico in presenza di
											sintomi e, se ancora sintomatici, al quinto giorno successivo alla data dell’ultimo contatto.
										</Typography>
										<Typography color={"textSecondary"}>
											Una volta compilata l'intervista ed indicato correttamente tutti i campi, un
											operatore ti contatterà. Per ulteriori domande <a
											href={"https://ocean.aslcittaditorino.it/contattaci"} target={"_blank"}
											rel={"noreferrer"}>contattaci</a>.
										</Typography>
									</Grid>
									
									<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
										<Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
										        onClick={methods.handleSubmit(onSubmit)} disabled={submit}
										        style={{fontSize: 18, borderRadius: 24}}>
											<b>Invia intervista</b>
										</Button>
									</Grid>
								
								</Grid>
							</FormProvider>
						</form>
					</Paper>
				</article>
				<footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
					<Copyright/>
				</footer>
			</main>
            <Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
				<SnackAlert style={{borderRadius: 28}} onClose={handleCloseSnack}
				            severity={appContext.state.severity}>
					{appContext.state.message}
				</SnackAlert>
			</Snackbar>
            <SimpleDialog
				open={openInformativa}
				title={"Benvenuto su Atlantis!"}
				content={
					<DialogContentText component={"div"}>
						<b>Informativa e privacy</b><br/>
						
						Gentile Sig./Sig.ra,<br/>
						
						I dati personali che conferirà con la compilazione del presente modulo on line saranno trattati utilizzando
						modalità manuali, informatiche e telematiche, nel rispetto e nei limiti stabiliti dalla normativa
						vigente.<br/>
						<br/>
						DICHIARAZIONE DI PRESA VISIONE DELL’INFORMATIVA PRIVACY. Dichiaro di avere letto e preso conoscenza delle
						informazioni, rese ai sensi dell’art. 13 del Regolamento UE 2016/679, relative al trattamento dei miei dati
						personali, pubblicate alla pagina web {" "}
						<a style={{color: theme.palette.primary.main}}
						   href={"https://www.regione.piemonte.it/web/note-legali-privacy"}
						   target="_blank"
						   rel="noreferrer">https://www.regione.piemonte.it/web/note-legali-privacy</a>.<br/>
						<FormControlLabel
							control={
								<Checkbox
									color={"primary"}
									checked={read}
									onChange={() => setRead(!read)}
									name="read"/>
							}
							label={"Ho letto integralmente e compreso l'informativa sul trattamento dei dati personali"}
						/>
					</DialogContentText>
				}
				actions={
					<DialogActions>
						<Button variant={"contained"} disableElevation size={"small"} className={classes.roundButton}
						        color={"primary"} style={{borderRadius: 24}}
						        onClick={() => setOpenInformativa(false)} disabled={!read}>
							<b>Confermo</b>
						</Button>
					</DialogActions>
				}
			/>
            {
				success && <Dialog open={success} PaperProps={{
					className: clsx(classes.roundBorder)
				}}>
					<DialogTitle>
						<b>Ottimo lavoro! 👍</b>
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Hai completato l'intervista! Resta a disposizione per eventuali chiamate dagli
							operatori dell' ASL.<br/>
							Ora puoi chiudere questa finestra o tab, riceverai ulteriori comunicazioni da un'operatore dell'ASL.
						</DialogContentText>
					</DialogContent>
				</Dialog>
			}
        </React.Fragment>
    );
};

function SnackAlert(props) {
	return <MuiAlert elevation={16} variant="filled" {...props} />;
}

export default React.memo(IntervistaCasoIndice);
